import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import { ReactComponent as ReceiptES } from "../../assets/empty-states/receipt-es.svg";
import { useEffect, useState } from "react";
import { BalootUserV3APIs } from "../../api/APIs";
import { useRequest } from "../../api/utils/useRequest";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import WalletTransactionCard from "../../components/receipt/WalletTransactionCard";
import FilterWrapper from "../../components/receipt/FilterWrapper";
import FilterInfoBox from "../../components/receipt/FilterInfoBox";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSnackBar } from "../../context/SnackBarContext";
import CustomRectangularSkeleton from "../../components/shared/CustomRectangularSkeleton";
import CustomTextSkeleton from "../../components/shared/CustomTextSkeleton";
import moment from "moment-jalaali";

const paramEnum = {
  page: "page",
  size: "size",
  statusGroup: "status.equals",
  depositGroup: "type.in",
  withdrawGroup: "type.in",
  date: "dateTime.greaterThanOrEqual",
};

function ReceiptPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const fromCashOut = location.state?.fromCashOut;
  const openSnack = useSnackBar();
  const [walletTransactions, setWalletTransactions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [error, serError] = useState(false);
  const LIMIT = 20;
  const [page, setPage] = useState(0);
  const [filterBarVisibility, setFilterBarVisibility] = useState(false);

  const {
    loading,
    result,
    apiCall: getWalletTransactions,
  } = useRequest(BalootUserV3APIs.walletTransactions, true);
  const DefaultFilter = {
    date: "ALL",
    statusGroup: "ALL",
    withdrawGroup: [],
    depositGroup: [],
  };
  const [filters, setFilters] = useState({ ...DefaultFilter });

  useEffect(() => {
    setPage(0);
    setParams(filters, 0);
  }, [filters]);

  const setParams = (filters, currentPage) => {
    var searchParams = new URLSearchParams();
    for (const key of Object.keys(filters)) {
      const param = filters[key];
      if (Array.isArray(param)) {
        for (const p of param) {
          searchParams.append(paramEnum[key], p);
        }
      } else if (key == "date") {
        if (param && param !== "ALL") {
          let newDate = setCorrectDate(param);
          searchParams.append(paramEnum[key], newDate);
        }
      } else {
        if ((param && param !== "ALL") || (!param && paramEnum[key] == "page"))
          searchParams.append(paramEnum[key], param);
      }
    }
    getPageWalletTransactions(currentPage, searchParams);
  };

  const setCorrectDate = (title) => {
    switch (title) {
      case "lastDay":
        return moment().subtract(1, "days").format();
      case "lastWeek":
        return moment().subtract(1, "weeks").format();
      case "lastMonth":
        return moment().subtract(1, "months").format();
      case "lastYear":
        return moment().subtract(1, "years").format();
    }
  };

  const resetFilters = () => {
    setFilters({ ...DefaultFilter });
  };

  const getPageWalletTransactions = (currentPage, params) => {
    let searchParams = params || new URLSearchParams();
    searchParams.append("page", currentPage);
    searchParams.append("size", LIMIT);
    getWalletTransactions({
      data: searchParams,
      onSuccess: (response) => {
        if (currentPage == 0) {
          setWalletTransactions(response.transactions.content);
        } else {
          setWalletTransactions((prev) => [
            ...prev,
            ...response.transactions.content,
          ]);
        }
        setHasMore(!response.transactions.last);
        setPage((prev) => prev + 1);
      },
      onError: (error) => {
        openSnack(true, { message: error.message });
        setHasMore(false);
        serError(true);
      },
    });
  };

  const hasFilter = () => {
    if (
      filters?.date !== "ALL" ||
      filters?.statusGroup !== "ALL" ||
      filters?.depositGroup?.length > 0 ||
      filters?.withdrawGroup?.length > 0
    )
      return true;
    else return false;
  };
  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton
            onClick={() => {
              if (fromCashOut) {
                navigate("/app/navigation/home");
              } else {
                navigate(-1);
              }
            }}
          >
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            صورت‌حساب
          </Typography>
        }
      />

      <PageContentContainer
        id="scrollableDiv"
        sx={{
          overflow: "auto",
          display: "block",
        }}
      >
        {loading && page === 0 ? (
          <>
            <FilterWrapper
              loading={loading}
              filterBarVisibility={filterBarVisibility}
              setFilterBarVisibility={setFilterBarVisibility}
              filters={filters}
              setFilters={setFilters}
              resetFilters={resetFilters}
              hasFilter={hasFilter}
            />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={60} />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={60} />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={60} />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
          </>
        ) : (
          <>
            {result && walletTransactions.length === 0 ? (
              <>
                {!hasFilter() ? (
                  <Box
                    sx={{
                      mt: 4,
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <ReceiptES width={160} height={200} />
                    <Typography mt={1} variant="subtitle1" color="grey.4">
                      اینجا تمام تراکنش‌های قلک خود را مشاهده خواهید کرد.
                    </Typography>
                  </Box>
                ) : (
                  <>
                    <FilterWrapper
                      loading={loading}
                      filterBarVisibility={filterBarVisibility}
                      setFilterBarVisibility={setFilterBarVisibility}
                      filters={filters}
                      setFilters={setFilters}
                      resetFilters={resetFilters}
                      hasFilter={hasFilter}
                    />
                    <Box
                      mt={1}
                      sx={{
                        borderRadius: `8px !important`,
                        boxShadow: `0px 2px 4px 1px #d9d7d6`,
                        py: "5px",
                        px: "8px",
                      }}
                    >
                      <Typography variant="subtitle1" color="grey.9">
                        تراکنشی با فیلتر درخواست شده وجود ندارد
                      </Typography>
                    </Box>
                  </>
                )}
              </>
            ) : (
              result && (
                <>
                  <FilterWrapper
                    loading={loading}
                    filterBarVisibility={filterBarVisibility}
                    setFilterBarVisibility={setFilterBarVisibility}
                    filters={filters}
                    setFilters={setFilters}
                    resetFilters={resetFilters}
                    hasFilter={hasFilter}
                  />
                  {hasFilter() && (
                    <Box
                      sx={{
                        my: "15px",
                      }}
                    >
                      <FilterInfoBox data={result} />
                    </Box>
                  )}

                  <InfiniteScroll
                    dataLength={walletTransactions.length}
                    next={() => setParams(filters, page)}
                    hasMore={hasMore}
                    loader={
                      <Box
                        sx={{
                          my: 1,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <CircularProgress size={14} />
                      </Box>
                    }
                    scrollableTarget="scrollableDiv"
                  >
                    {walletTransactions.map((walletTransaction, index) => {
                      return (
                        <WalletTransactionCard
                          key={walletTransaction.id}
                          walletTransaction={walletTransaction}
                          first={index === 0}
                        />
                      );
                    })}
                  </InfiniteScroll>
                </>
              )
            )}
          </>
        )}
      </PageContentContainer>
    </>
  );
}

export default ReceiptPage;
